/// <amd-module name="Release/Landing/LeftPanel/AllPipelines/AllDefinitionsActions" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { Folder, ReleaseDefinition, Release } from "Release/Client/Contracts/Release";

export interface IPipelineMovedPayload {
    movedPipeline: ReleaseDefinition;
    originalPath: string;
}

export interface IRenameFolderPayload {
    folder: Folder;
    oldPath: string;
}

export class AllDefinitionsActions extends ActionsHubBase {
    public static getKey(): string {
        return "all-definitions-actions";
    }

    public initialize(): void {
        this._folderCreated = new Action<Folder>();
        this._pipelineRenamed = new Action<ReleaseDefinition>();
        this._folderRenamed = new Action<IRenameFolderPayload>();
        this._pipelineMoved = new Action<IPipelineMovedPayload>();
        this._pipelinesFetched = new Action<{} | undefined>();
        this._fetchingPipelines = new Action<{} | undefined>();
        this._folderToggled = new Action<string>();
    }

    public get folderCreated(): Action<Folder> {
        return this._folderCreated;
    }

    public get pipelineRenamed(): Action<ReleaseDefinition> {
        return this._pipelineRenamed;
    }

    public get folderRenamed(): Action<IRenameFolderPayload> {
        return this._folderRenamed;
    }

    public get pipelineMoved(): Action<IPipelineMovedPayload> {
        return this._pipelineMoved;
    }

    public get pipelinesFetched(): Action<{} | undefined> {
        return this._pipelinesFetched;
    }

    public get fetchingPipelines(): Action<{} | undefined> {
        return this._fetchingPipelines;
    }

    public get folderToggled(): Action<{} | undefined> {
        return this._folderToggled;
    }

    private _pipelinesFetched: Action<{} | undefined>;
    private _folderCreated: Action<Folder>;
    private _pipelineRenamed: Action<ReleaseDefinition>;
    private _folderRenamed: Action<IRenameFolderPayload>;
    private _pipelineMoved: Action<IPipelineMovedPayload>;
    private _fetchingPipelines: Action<{} | undefined>;
    private _folderToggled: Action<string>;
}
